import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button } from 'reactstrap';
import _ from 'lodash';
import './LicenseAgreementModal.css';
import LicenseComponent from '../../../license/LicenseComponent';
import IconContainer from '../iconContainer/IconContainer';
import { sharedLabelsPath } from '../../../reducers/common/localization';

class LicenseAgreementModal extends Component {
    render() {
        return (
            <Modal className="license-agreement-modal" isOpen={this.props.isOpen} toggle={this.props.onCancel}>
                <div className="licence-agreement-modal-header" >
                <IconContainer 
                    icon='clear'
                    className="licence-agreement-modal-close-icon"
                    onClick={this.props.onCancel}
                    title={_.get(this.props.translation, sharedLabelsPath.cancel_button)}
                />
                </div>
                <ModalBody>
                    <div className="license-content-container">
                        <LicenseComponent />
                    </div>
                    <div className="license-agreement-modal-button-container">
                        <Button className="olive-green-btn" onClick={this.handleAgree}>
                            {_.get(this.props.translation, "license_agreement.agree_label") + ' ' + _.get(this.props.translation, "license_agreement.agree_link")}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    handleAgree = () => {
        this.props.onAgree();
        this.props.onCancel();
    };
}

LicenseAgreementModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    onAgree: PropTypes.func
};

export default LicenseAgreementModal;



// WEBPACK FOOTER //
// ./src/components/commonComponents/licenseAgreement/LicenseAgreementModal.js